import { EventHub } from '@/constants/constants'
import { DialogSector } from '@/tools/dialog'
import { mapActions } from 'vuex'
import { sectorService } from '@/services/sector.service'

export default {
    name: 'EnterpriseSectorsTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        },
        update: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
    }),
    computed: {
    },
    created () {
        // Evento lanzado por el diálogo de creación de finca, cuando se guarda la nueva finca
        this.$eventBus.$on(EventHub.COMMIT_SECTOR, (sectorDto) => {
            this.model.sectors = this.model.sectors.concat([sectorDto]);
        })
    },
    beforeDestroy () {
        // desuscripción al bus de eventos
        this.$eventBus.$off(EventHub.COMMIT_SECTOR)
    },
    mounted () {
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Carga el dialog para crear un sector
         */
        openSector() {
            const bread = {
                key: DialogSector,
                disabled: true,
                text: this.$t('sector.name'),
                model: { sectors: this.model.sectors }
            }
            this.pushBread(bread)
        },
        async removeSector(item, index) {
            if (item._id) {
                const canDelete = await sectorService.canDeleteSector(item._id)
                if (canDelete) {
                    this.model.sectors.splice(index, 1)
                }
            } else {
                this.model.sectors.splice(index, 1)
            }
        }
    },
    watch: {
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.enterpriseSectorsForm) {
                this.$refs.enterpriseSectorsForm.resetValidation()
            }
        }
    }
}
